const DELAY_BETWEEN_REQUESTS = 1500;
let lastRequestTime = 0;

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export async function geocodeAddress(address: string, city: string): Promise<{ lat: number; lng: number } | null> {
  try {
    const now = Date.now();
    const timeSinceLastRequest = now - lastRequestTime;
    if (timeSinceLastRequest < DELAY_BETWEEN_REQUESTS) {
      await delay(DELAY_BETWEEN_REQUESTS - timeSinceLastRequest);
    }
    
    lastRequestTime = Date.now();

    // Usa direttamente OpenStreetMap Nominatim con headers appropriati
    const query = encodeURIComponent(`${address}, ${city}, Italy`);
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${query}&limit=1`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'PizzaVeg App (https://pizzaveg.it)',
        'Accept-Language': 'it',
        'Referer': 'https://pizzaveg.it'
      }
    });

    if (!response.ok) {
      console.warn(`Geocoding fallito per ${address}, ${city}. Status: ${response.status}`);
      return getDefaultCityCoordinates(city);
    }

    const data = await response.json();
    
    if (data && data[0]) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon)
      };
    }
    
    return getDefaultCityCoordinates(city);
    
  } catch (error) {
    console.error('Errore nella geocodifica:', error);
    return getDefaultCityCoordinates(city);
  }
}

function getDefaultCityCoordinates(city: string): { lat: number; lng: number } {
  const cityCoordinates: { [key: string]: { lat: number; lng: number } } = {
    'Roma': { lat: 41.9028, lng: 12.4964 },
    'Milano': { lat: 45.4642, lng: 9.1900 },
    'Napoli': { lat: 40.8518, lng: 14.2681 },
    'Torino': { lat: 45.0703, lng: 7.6869 },
    'Palermo': { lat: 38.1157, lng: 13.3615 },
    'Genova': { lat: 44.4056, lng: 8.9463 },
    'Bologna': { lat: 44.4949, lng: 11.3426 },
    'Firenze': { lat: 43.7696, lng: 11.2558 },
    'Bari': { lat: 41.1171, lng: 16.8719 },
    'Venezia': { lat: 45.4371, lng: 12.3326 },
    'Verona': { lat: 45.4384, lng: 10.9917 }
  };

  const normalizedCity = city.trim().toLowerCase();
  const matchedCity = Object.keys(cityCoordinates).find(c => 
    normalizedCity.includes(c.toLowerCase())
  );

  return matchedCity 
    ? cityCoordinates[matchedCity] 
    : cityCoordinates['Roma']; // Default a Roma
} 